export const getConsumerCPF = () => {
  try {
    const data = localStorage.getItem("consumerSMS");
    if (!data) return null;

    const parsed = JSON.parse(data);
    return parsed?.consumer?.cpf ?? null;
  } catch (error) {
    console.error("Erro ao acessar/parsing localStorage:", error);
    return null;
  }
};
